import { render } from "./FloatingWindow.vue?vue&type=template&id=08118df2&scoped=true"
import script from "./FloatingWindow.vue?vue&type=script&lang=js"
export * from "./FloatingWindow.vue?vue&type=script&lang=js"

import "./FloatingWindow.vue?vue&type=style&index=0&id=08118df2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08118df2"]])

export default __exports__